var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookConsult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18336",
    transform: "translate(-390 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 170",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(390 462)",
    style: {
      fill: "#ea5d6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20",
    d: "M10.282 21.325h12.71a.82.82 0 1 0 0-1.64h-12.71a.82.82 0 0 0 0 1.64z",
    transform: "translate(401.51 472.772)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M17.891 25.39h-7.609a.82.82 0 0 0 0 1.64h7.609a.82.82 0 1 0 0-1.64z",
    transform: "translate(401.51 472.398)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M31.891 22.031V7.6a4.176 4.176 0 0 0-4.175-4.17h-3.423V1.835a.835.835 0 0 0-1.67 0V3.43H11.268V1.835a.835.835 0 0 0-1.67 0V3.43H6.175A4.176 4.176 0 0 0 2 7.6v22.621A4.176 4.176 0 0 0 6.175 34.4H21.63a9.185 9.185 0 1 0 10.261-12.369zM6.183 5.1h3.424v1.594a.835.835 0 0 0 1.67 0V5.1h11.355v1.594a.835.835 0 0 0 1.67 0V5.1h3.423a2.512 2.512 0 0 1 2.5 2.5v2.02H3.678V7.6a2.507 2.507 0 0 1 2.505-2.5zm0 27.626a2.512 2.512 0 0 1-2.5-2.5v-18.94h26.538v10.586H30.2a9.2 9.2 0 0 0-9.034 10.854zM30.2 38.57a7.514 7.514 0 1 1 7.514-7.514A7.514 7.514 0 0 1 30.2 38.57z",
    transform: "translate(402 474)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "m35.384 29.762-4.87 4.649L28 31.886a.817.817 0 1 0-1.156 1.156l3.091 3.091a.806.806 0 0 0 .582.238.793.793 0 0 0 .566-.23l5.445-5.207a.816.816 0 0 0 .025-1.156.834.834 0 0 0-1.169-.016z",
    transform: "translate(400.384 472.125)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookConsult);
export default __webpack_public_path__ + "static/media/book-consult.a4112a536215c3588b62c0525056062f.svg";
export { ForwardRef as ReactComponent };